import { ClientFieldsFragment } from '@/@generated/codegen/API';
import createTanstackTableDataStore from '@/ui/TanstackTable/createTanstackTableDataStore';

const useAdminClientTableStore = createTanstackTableDataStore<ClientFieldsFragment>({
  storeName: 'admin-client-table-store',
  defaultColumnSizing: {},
  defaultColumnVisibility: {},
});

export default useAdminClientTableStore;
